import React from 'react';
import { SkillData, ToolsData } from '../../Store';
import './skill.scss'

const Skill = () => {
    const skillData = SkillData;
    const toolsData = ToolsData;
    return (
        <div className="skill">
            <div className="container">
                <div className="component-head">
                    <h2>Skill</h2>
                </div>

                <div className="skills">
                    {
                        skillData.map(skill => <div className="skill-card"><img src={skill.image} alt="skill" /><h4>{skill.title}</h4></div>)
                    }
                </div>
                <hr></hr>

                <div className="skills">
                    {
                        toolsData.map(tool => <div className="skill-card"><img src={tool.image} alt="tools" /><h4>{tool.title}</h4></div>)
                    }
                </div>
            </div>
            
        </div>
    );
};

export default Skill;